import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import SoleraLoader from "components/UI/Loader/SoleraLoader";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";

export const mapStateToProps = state => {
  return {
    open: state.loader.open,
    calls: state.loader.calls
  };
};

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      showLoader: showLoader,
      hideLoader: hideLoader
    },
    dispatch
  );
};

const SoleraLoaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SoleraLoader);

export default SoleraLoaderContainer;
